import {
  USR_CONFIGURACAO_NOTIFICACAO_FALHA,
  USR_CONFIGURACAO_NOTIFICACAO_SUCESSO,
  USR_SET_PESSOA_FAIL,
  USR_SET_PESSOA_LOGADA_FAIL,
  USR_SET_PESSOA_LOGADA_SUCCESS,
  USR_SET_PESSOA_SUCCESS,
} from './types';
import box from '../api/box';
import { createSuccessNotification, sendErroRequest } from '../utils/Notification';

export const setPessoaLogadaSuccess = values => ({
  type: USR_SET_PESSOA_LOGADA_SUCCESS,
  payload: values,
});

export const setPessoaLogadaFail = () => ({
  type: USR_SET_PESSOA_LOGADA_FAIL,
});

export const setDadosPessoaSuccess = values => ({
  type: USR_SET_PESSOA_SUCCESS,
  payload: values,
});

export const setDadosPessoaFail = () => ({
  type: USR_SET_PESSOA_FAIL,
});

const setConfiguracaoNotificaoSucesso = payload => ({
  type: USR_CONFIGURACAO_NOTIFICACAO_SUCESSO,
  payload,
});

const setConfiguracaoNotificaoFalha = () => ({
  type: USR_CONFIGURACAO_NOTIFICACAO_FALHA,
});

export const getPessoaLogada = () => async dispatch => {
  try {
    const { data } = await box.get('v2/pessoas-usuarios/pessoa-logada');

    dispatch(setPessoaLogadaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados da Pessoa Logada');

    dispatch(setPessoaLogadaFail());
  }
};

export const getPessoa = () => async (dispatch, getState) => {
  const {
    usuario: { pessoaLogada },
  } = getState();

  try {
    const { data } = await box.get(`/pessoas/${pessoaLogada.id}`);

    dispatch(setDadosPessoaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados da Pessoa');

    dispatch(setDadosPessoaFail());
  }
};

export const putPessoa = (pessoa, cb) => async dispatch => {
  try {
    const { data } = await box.put('/v1/empresas/pessoa', pessoa);

    createSuccessNotification(data.mensagem);

    dispatch(setDadosPessoaSuccess(pessoa));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível atualizar os dados da Pessoa');

    dispatch(setDadosPessoaFail());
  }
};

export const postPessoa = pessoa => async (dispatch, getState) => {
  try {
    const {
      empresa: {
        dadosEmpresa: { id },
      },
      usuario: {
        pessoaLogada: { nome, tipo, usuarioId },
      },
    } = getState();

    const pessoaUsuario = {
      ...pessoa,
      empresaId: id,
      email: nome,
      tipo,
      usuarioId,
    };

    await box.post('/v1/empresas/pessoa', pessoaUsuario);

    dispatch(window.location.reload());
  } catch (error) {
    dispatch(setDadosPessoaFail());
  }
};

export const obterConfiguracaoNotificacao = () => async dispatch => {
  try {
    const { data } = await box.get('/configuracoes-usuario');

    dispatch(setConfiguracaoNotificaoSucesso(data));
  } catch (error) {
    dispatch(setConfiguracaoNotificaoFalha());
  }
};

export const alterarConfiguracaoNotificacao = (data, cb) => async dispatch => {
  try {
    await box.post('/configuracoes-usuario', data);

    dispatch(setConfiguracaoNotificaoSucesso(data));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    dispatch(setConfiguracaoNotificaoFalha());
  }
};
